// extracted by mini-css-extract-plugin
module.exports = {"subContainer":"e_tA","credits":"e_uA","badgeContainer":"e_vA","badge":"e_wA"};